//Common
import { api } from "../../common/CloudService/ApiPromisify";
//ClientLibsReference
import { CloudService } from "../../common/CloudService/ClientLibsReference";

export class LoginViewModel {
  loginApiV1LoginListBusinesses = async request => {
    let loginResponse = {};
    let loginRequest = CloudService.LoginRequest.constructFromObject(request);

    await api("loginApiV1LoginListBusinesses", loginRequest).then(res => {
      if (res.data) {
        loginResponse = CloudService.LoginResponse.constructFromObject(
          res.data
        );
      }
    });

    return loginResponse;
  };

  loginApiV1Login = async request => {
    let loginResponse = {};
    let loginRequest = CloudService.LoginRequest.constructFromObject(request);

    await api("loginApiV1Login", loginRequest).then(res => {
      if (res.data) {
        loginResponse = CloudService.LoginResponse.constructFromObject(
          res.data
        );
      }
    });

    return loginResponse;
  };
}



// WEBPACK FOOTER //
// ./src/components/Login/LoginViewModel.js